import { Card, CardContent } from "@/components/ui";
import { Typography } from "../typography";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { IconButton } from "@/components/ui/icon-button";

export const CreateNewProfileCard = ({ onClick }: { onClick: () => void }) => {
  const { isMobile } = useWindowDimensions();

  return (
    <Card
      className="border border-dashed border-border"
      onClick={isMobile ? onClick : undefined}
    >
      <CardContent className="flex flex-row items-center justify-between">
        <Typography variant="body-md">Create new profile</Typography>
        <IconButton variant="ghost" iconName="plus" onClick={onClick} />
      </CardContent>
    </Card>
  );
};
